import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';

const ErrorPage = ({icon, title, subtitle, btn}) => {
  return (
    <div className='business-client-esim-upgrade-error-page'>
      <div className='error-header'>
        <Image src={icon} className='error-icon' />
        <div className='titles-area'>
          <span className='error-title'>{title}</span>
          <span className='error-subtitle'>{subtitle}</span>
        </div>
      </div>
      {btn}
    </div>
  );
};
export default ErrorPage;
